<template>
  <button
    type="button"
    class="ai-suggestion-icon"
    :class="{
      'ai-suggestion-icon-disabled': disabled,
      'ai-suggestion-icon-inline': inline,
    }"
    :disabled="disabled"
    title="Sugerir con IA"
    @click="$emit('click', $event)"
  >
    <!-- fa-wand-magic-sparkles no esta disponible en el kit de Font Awesome de este proyecto
         (por eso se veia el boton vacio, solo el circulo verde sin icono). Se usa el mismo
         icono "sparkles" del Asistente Virtual ya existente en la app, ahora extraido a
         AiSparkIcon.vue (variante blanca, porque el chip va sobre el gradiente violeta). -->
    <AiSparkIcon :size="14" variant="white" />
    <!-- Texto "Usar IA" agregado junto al ícono (antes era solo el círculo del sparkle) --
         el mockup de Figma muestra el chip disparador con texto, no solo el ícono. Se usa
         "IA" (no "Ai" como aparece en Figma) para seguir la convención en español del resto
         de la app (ej. "Objetivo con Asistente IA", "Redacción Sugerida"). -->
    <span>Usar IA</span>
  </button>
</template>

<script>
import AiSparkIcon from '@/components/pei/shared/ai-assistant/AiSparkIcon.vue';

export default {
  name: 'AiSuggestionIcon',
  components: {
    AiSparkIcon,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    // Variante para usar el chip junto a un título en vez de anclado en el textarea.
    inline: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.ai-suggestion-icon {
  /* Posición tomada de Figma (nodo "Bot Icon", hijo del recuadro real del textarea -- ver
     Frame 7147 > "Información General del PEI o PS" > Textarea > Textarea > Bot Icon,
     x≈1218 de 1226 de ancho, y≈24 de 79 de alto): el chip va pegado a la ESQUINA SUPERIOR
     derecha, dentro del recuadro, no abajo. Se usa un "top" fijo (no "bottom") para que
     quede anclado ahí sin importar cuánto crezca el alto del textarea real (que es más
     alto que la muestra de Figma). Forma de pill (no círculo) porque ahora lleva texto
     "Usar IA" además del ícono, como el chip "+ Usar Ai" del mismo nodo "Bot Icon" en
     Figma (6084:23752, mockup de la Tab II) -- border #e9e1ff y gradiente violeta tomados
     de ese mismo nodo; reemplaza el círculo coral que tenía este ícono antes de que el
     esquema de color de Figma para el asistente de IA se adoptara (ver AiAssistantModal.vue
     y .ai-objetive-trigger en SubAreaGoalCallout.vue). */
  position: absolute;
  top: 10px;
  right: 14px;
  height: 28px;
  padding: 0 10px 0 8px;
  border-radius: 20px;
  border: 2px solid #e9e1ff;
  background: linear-gradient(104deg, #5c58ed 24.303%, #ba65ff 134.64%);
  color: #fff;
  font-family: 'Lato', sans-serif;
  font-weight: 600;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  z-index: 2;
}

.ai-suggestion-icon:hover:not(.ai-suggestion-icon-disabled) {
  background: linear-gradient(104deg, #4a45d6 24.303%, #a94dff 134.64%);
}

.ai-suggestion-icon-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Variante inline: posición estática en vez de absoluta, para ir junto a un título. */
.ai-suggestion-icon-inline {
  position: static;
  top: auto;
  right: auto;
  height: 24px;
  margin-left: 8px;
  vertical-align: middle;
}
</style>
